// What the "Iniciar respuesta" dialog offers and sends. Kept free of React so
// the choices can be tested without mounting the dialog.
//
// The server (gfunctions/pqrsd/startPqrsdResponseFlow/responseChain.js) is the
// one that enforces all of this; the dialog only keeps an operator from
// building something it would refuse.

import {
  answerKey,
  documentStatus,
  normalizeDocumentsConfig,
} from "./config/documentTemplates";

// Same cap as MAX_STEPS on the server: elaborate + 6 in between + sign.
export const MAX_MIDDLE_STEPS = 6;

export const MIDDLE_STEP_TYPES = [
  { value: "review", label: "Revisión" },
  { value: "approve", label: "Aprobación" },
];

// Answer templates an operator may start from: active, with a generated
// document. A stale one still works (it renders the last build), so it is
// offered but flagged.
export function availableAnswerTemplates(documents) {
  const docs = normalizeDocumentsConfig(documents);
  return docs.answers
    .filter((a) => a.active && a.merged.url)
    .map((a) => ({
      id: a.id,
      name: a.name,
      stale: documentStatus(docs, answerKey(a.id)) === "stale",
    }));
}

// The receiver list returns every account. Company accounts (userType ENTITY)
// and disabled ones cannot own a step: the server refuses them.
export function selectableUsers(users) {
  return (Array.isArray(users) ? users : [])
    .filter((u) => u && u.userId && u.userType !== "ENTITY" && u.disabled !== true)
    .sort((a, b) => `${a.name || ""} ${a.lastName || ""}`.localeCompare(`${b.name || ""} ${b.lastName || ""}`, "es"));
}

export const userLabel = (u) =>
  u ? `${`${u.name || ""} ${u.lastName || ""}`.trim() || u.email || u.userId}${u.email ? ` <${u.email}>` : ""}` : "";

// null when the chain is complete, otherwise what is missing (Spanish copy).
export function chainProblem({ elaborator, middle, signer }) {
  if (!elaborator?.userId) return "Seleccione quién elabora la respuesta.";
  const missing = middle.findIndex((s) => !s.user?.userId);
  if (missing > -1) return `Seleccione el funcionario del paso ${missing + 2}.`;
  if (!signer?.userId) return "Seleccione quién firma la respuesta.";
  return null;
}

export function stepsPayload({ elaborator, middle, signer }) {
  return [
    { type: "elaborate", userId: elaborator.userId },
    ...middle.map((s) => ({ type: s.type, userId: s.user.userId })),
    { type: "sign", userId: signer.userId },
  ];
}
